import React from "react";
import Header from "./components/Header.js";
import Body from "./components/Body.js";
import { Marker, Popup } from "react-leaflet";

export default function App() {
    const [stateData, changeStateData] = React.useState({
        headerData: {
            onn: false,
            values: { transform: "translateY(-36vh)" },
        },
        mapData: {
            attribution:
                '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
            url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
            center: [30.3068862, 77.8992136],
            zoom: 13,
            scroolWheelZoom: true,
        },
        mapPoints: [],
        maps: [
            {
                attribution:
                    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            },
            {
                url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
                attribution:
                    "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
            },
            {
                attribution:
                    '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
                url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
            },
        ],
    });

    React.useEffect(() => {
        changeStateData(
            localStorage.getItem("stateData") != null
                ? JSON.parse(localStorage.getItem("stateData"))
                : {
                      headerData: {
                          onn: false,
                          values: { transform: "translateY(-36vh)" },
                      },
                      mapData: {
                          attribution:
                              '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
                          url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
                          center: [30.3068862, 77.8992136],
                          zoom: 13,
                          scroolWheelZoom: true,
                      },
                      mapPoints: [],
                      maps: [
                          {
                              attribution:
                                  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                              url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                          },
                          {
                              url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
                              attribution:
                                  "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
                          },
                          {
                              attribution:
                                  '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
                              url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
                          },
                      ],
                  }
        );
    }, []);
    let [infoButton, changeInfoButton] = React.useState("none");
    let closeInfo = function () {
        changeInfoButton("none");
    };
    return (
        <section className="app" id="app">
            <Header
                changeStateData={changeStateData}
                stateData={stateData}
                changeInfoButton={changeInfoButton}
            />
            <Body changeStateData={changeStateData} stateData={stateData} />
            <div
                className="absolute-info"
                style={{ display: infoButton, position: "absolute" }}
            >
                <div className="info-box">
                    <div className="close-info">
                        <div className="close-button" onClick={closeInfo}>
                            CLOSE
                        </div>
                    </div>
                    <div className="note-imp">
                        NOTE: please ensure to enable location on mobile devices
                    </div>
                    <p className="info-box-paragraph">
                        This projects is a minimalistic location finder and
                        logger. Made for the purpose of leaving notes so as to
                        keep track of location based info. Utilizes concepts of
                        React, Geolocation API, Local Storage, Leaflet Library
                        and React-Leaflet. The code for this project is
                        available on my github. For additional information on
                        react-leaflet check the npm guidelines. This is a
                        lerning project so dont claim as your own or use to
                        teach.{" "}
                    </p>
                    <p className="credit">
                        Made by{" "}
                        <span className="preetam-singh">SIMRAN RAWAT</span> and
                        uses{" "}
                        <span className="leaflet-name">LEAFLET LIBRARY</span>
                    </p>
                </div>
            </div>
        </section>
    );
}
